<template>
    <div class="lottery" @touchmove.prevent>
        <!-- 顶部元素 -->
        <img src="http://cdn.shikehuyu.com/card/game-link.png?v=1.0.3" class="lottery__link">
        <img src="http://cdn.shikehuyu.com/card/game-click.png?v=1.0.1" class="lottery__click" @click="jump">
        <img src="http://cdn.shikehuyu.com/card/game-link-finger.png?v=1.0.0" class="lottery__link__finger wanderVer1">
        <img :src="musicIcon" class="lottery__music" @click="toggleMusic">
        <!-- 底部元素 -->
        <img src="http://cdn.shikehuyu.com/card/game-logo.png?v=1.0.0" class="lottery__logo">
        <img src="http://cdn.shikehuyu.com/card/lottery-title.png?v=1.0.0" class="lottery__title">
        <img src="http://cdn.shikehuyu.com/card/lottery-subtitle.png?v=1.0.0" class="lottery__subtitle">
        <!-- 抽奖盒子 -->
        <div class="lottery__box">
            <img src="http://cdn.shikehuyu.com/card/lottery-box.png?v=1.0.0" class="lottery__box__bg">
            <img src="http://cdn.shikehuyu.com/card/lottery-btn.png?v=1.0.0" class="lottery__box__btn"
                :class="{ disabled: !enabled }"
                @click="lottery">
            <div class="lottery__box__lights"
                :class="'lottery__box__lights--' + n"
                v-for="n in 4"
                :key="'lottery__box__lights' + n">
                <div class="lottery__box__lights__item"
                    v-for="x in 7"
                    :key="'lottery__box__lights__item' + x"
                    :class="{ active: isLightActive(n, x) }">
                </div>
            </div>
            <div class="lottery__box__item"
                :class="(item.active ? 'active' : '')
                    + (' lottery__box__item--' + index)"
                v-for="(item, index) in lotteryItems"
                :key="index">
                <img :src="'http://cdn.shikehuyu.com/card/lottery-gift-' + item.type + '.png?v=1.0.0'"
                    class="lottery__box__item__gift">
            </div>
        </div>
        <!-- 抽不中 -->
        <transition name="fade">
            <div class="lottery__miss" v-show="showMiss">
                <div class="lottery__miss__cnt">
                    <div class="lottery__miss__cnt__inner animated bounceInDown">
                        <img src="http://cdn.shikehuyu.com/card/lottery-modal.png?v=1.0.0" class="lottery__miss__cnt__inner__bg">
                        <img src="http://cdn.shikehuyu.com/card/lottery-again.png?v=1.0.0" class="lottery__miss__cnt__inner__again"
                            @click="playAgain">
                        <img src="http://cdn.shikehuyu.com/card/game-giveup.png?v=1.0.0" class="lottery__miss__cnt__inner__giveup"
                            @click="giveup">
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'lottery',
    data() {
        const lotteryItemPics = [0, 0, 1, 1, 1, 2, 2, 2];
        const lotteryItems = {};
        for (let i = 0; i < 8; i += 1) {
            const rnd = Math.floor(Math.random() * lotteryItemPics.length);
            lotteryItems[i] = {
                type: lotteryItemPics.splice(rnd, 1)[0],
                active: false
            };
        }
        return {
            musicOn: this.$bus.musicOn,
            enabled: true, // 是否允许点击抽奖
            lotteryItems,
            currentActiveLotteryItem: null,
            currentLight: 0, // 当前灯箱亮灯

            win: false, // 是否中奖
            lotteryTimes: 0, // 剩余滚动次数
            lotteryIndex: 0, // 滚到哪一个
            showMiss: false, // 显示不中
        };
    },
    computed: {
        musicIcon() {
            return `http://cdn.shikehuyu.com/card/icon-music-${this.musicOn ? 'on' : 'off'}.png?v=1.0.0`;
        },
    },
    methods: {
        jump() {
            this.$bus.playMusic('click');
            this.$bus.jump();
        },
        toggleMusic() {
            this.$bus.toggleMusic();
            this.musicOn = this.$bus.musicOn;
            if (this.musicOn) {
                this.$bus.musicFadeIn('bg', 0, 0.5);
            } else {
                this.$bus.musicFadeOut('bg', 0.5, 0);
            }
            this.$bus.playMusic('click');
        },
        isLightActive(n, x) {
            if (n % 2 === 1) {
                return x % 2 === ((this.currentLight + 1) >= 2 ? 0 : 1);
            }
            return x % 2 === this.currentLight;
        },
        lightsRoll() {
            this.currentLight = this.currentLight === 0 ? 1 : 0;
            this.lightsRollTimeout = setTimeout(() => {
                this.lightsRoll();
            }, 500);
        },
        lottery() {
            if (this.enabled) {
                this.$bus.playMusic('click');
                this.enabled = false;
                this.lotteryTimes = 25 + Math.round(Math.random() * 10);
                this.currentActiveLotteryItem = 7;
                this.lotteryRoll();
            }
        },
        lotteryRoll() {
            this.$bus.playMusic('lottery');
            this.lotteryTimes -= 1;
            const nextTime = this.getLotteryNextTime();
            this.lotteryItems[this.currentActiveLotteryItem].active = false;
            this.currentActiveLotteryItem = this.currentActiveLotteryItem >= 7
                ? 0 : this.currentActiveLotteryItem + 1;
            this.lotteryItems[this.currentActiveLotteryItem].active = true;
            if (this.lotteryTimes > 0) {
                this.lotteryRollTimeout = setTimeout(this.lotteryRoll, nextTime);
            } else {
                if (this.win) this.$bus.playMusic('success');
                setTimeout(() => {
                    if (this.win) {
                        this.$router.replace('form');
                    } else {
                        this.showMiss = true;
                    }
                }, 2000);
            }
        },
        getLotteryNextTime() {
            const k = 30 - this.lotteryTimes;
            return 50 + k * k * 0.6;
        },

        playAgain() {
            this.$router.replace({
                path: '/game',
                query: {
                    replay: 1
                }
            });
        },
        giveup() {
            this.$router.replace('share');
        }
    },
    mounted() {
        this.lightsRoll();
        window.lottery = this;
    },
    beforeDestroy() {
        clearTimeout(this.lightsRollTimeout);
    }
};
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';
@import '../style/animation.scss';

.lottery {
    @include fullscreen;
    @include bg-cover;
    overflow: hidden;
    background-image: url('http://cdn.shikehuyu.com/card/game-bg.png?v=1.0.0');
    &__link {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        left: 0;
        width: 14vw;
        &__finger {
            position: absolute;
            padding: 2vw 1vw;
            top: 2.5%;
            left: 2.5%;
            width: 8.5%;
            z-index: 1;
        }
    }
    &__click {
        position: absolute;
        padding: 8vw 1vw;
        top: 2%;
        left: -1%;
        width: 18%;
        z-index: 2;
    }
    &__music {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        right: 0;
        width: 12vw;
    }
    &__logo {
        @include transform-center-x;
        bottom: 3vh;
        width: 76vw;
    }
    &__title {
        position: absolute;
        left: 50%;
        bottom: 65vh;
        transform: translate(-50%, -5vh);
        width: 80vw;
    }
    &__subtitle {
        position: absolute;
        left: 50%;
        bottom: 60vh;
        transform: translate(-50%, -2vh);
        width: 56.3vw;
    }
    &__box {
        @include transform-center-x;
        width: 93.87vw;
        top: 40vh;
        &__bg {
            width: 100%;
            transform: translate(0, 1%);
        }
        &__btn {
            @include transform-center;
            width: 28.13vw;
            height: 23.33vw;
            transition: all linear .1s;
            &:active {
                -webkit-filter: brightness(0.9);
                filter: brightness(0.9);
            }
            &.disabled {
                opacity: 0.8;
            }
        }
        &__lights {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0px;
            &--1 {
                @include transform-center-x;
                top: 1.2vw;
                width: 80vw;
            }
            &--2 {
                @include transform-center-y;
                right: 0;
                flex-direction: column;
                height: 66vw;
            }
            &--3 {
                @include transform-center-x;
                bottom: 1.2vw;
                width: 80vw;
            }
            &--4 {
                @include transform-center-y;
                left: 0;
                flex-direction: column;
                height: 66vw;
            }
            &__item {
                @include bg-contain;
                width: 3.2vw;
                height: 3.2vw;
                background-image: url('http://cdn.shikehuyu.com/card/lottery-light-off.png?v=1.0.0');
                &.active {
                    background-image: url('http://cdn.shikehuyu.com/card/lottery-light-on.png?v=1.0.0');
                }
            }
        }
        &__item {
            @include box;
            position: absolute;
            top: 50%;
            left: 50%;
            background: linear-gradient(to top, #feeded, #fef2c8);
            width: 28.13vw;
            height: 23.33vw;
            border-radius: 3.4vw;
            &.active {
                background: linear-gradient(to top, #ffd490, #fd9476);
            }
            &--0 {
                transform: translate(-153%, -153%);
            }
            &--1 {
                transform: translate(-50%, -153%);
            }
            &--2 {
                transform: translate(53%, -153%);
            }
            &--3 {
                transform: translate(53%, -50%);
            }
            &--4 {
                transform: translate(53%, 53%);
            }
            &--5 {
                transform: translate(-50%, 53%);
            }
            &--6 {
                transform: translate(-153%, 53%);
            }
            &--7 {
                transform: translate(-153%, -50%);
            }
            &__gift {
                width: 16.4vw;
            }
        }
    }
    &__miss {
        @include fullfill;
        @include box;
        background: rgba(0, 0, 0, 0.8);
        &__cnt {
            transform: translate(0, -50%);
            &__inner {
                position: relative;
                font-size: 0px;
                &__bg {
                    width: 82vw;
                }
                &__again {
                    position: absolute;
                    bottom: 11.6%;
                    right: 50%;
                    transform: translate(-1vw, 0);
                    width: 30vw;
                }
                &__giveup {
                    position: absolute;
                    bottom: 11.6%;
                    left: 50%;
                    transform: translate(1vw, 0);
                    width: 30vw;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lottery.vue